import type { Schemas } from '@/lib/api/client'

/** An option that moves a price, or a colour group (`vehicles.options`, ticket 18). */
export type Option = Schemas['Option']
export type OptionRead = Schemas['OptionRead']

/** What each option is called on screen, in the vocabulary's order. */
export const OPTION_LABELS: Record<Option, string> = {
  sunroof: 'Sunroof or panoramic roof',
  leather: 'Leather',
  heated_seats: 'Heated or cooled seats',
  tow_bar: 'Tow bar',
  bull_bar: 'Bull bar',
  roof_racks: 'Roof racks',
  canopy: 'Canopy or tub',
  adaptive_cruise: 'Adaptive cruise',
  camera_360: '360 camera',
  premium_audio: 'Premium audio',
  head_up_display: 'Head-up display',
  sport_pack: 'Sport pack (M Sport, AMG Line…)',
  alloy_upgrade: 'Alloy wheel upgrade',
  colour_white: 'White',
  colour_black: 'Black',
  colour_grey: 'Grey or silver',
  colour_blue: 'Blue',
  colour_red: 'Red',
  colour_green: 'Green',
  colour_brown: 'Brown, beige or gold',
  colour_yellow: 'Yellow or orange',
  colour_other: 'Another colour',
}

/** A colour group, which comes from the car's colour rather than a tick. */
export function isColour(option: Option): boolean {
  return option.startsWith('colour_')
}

/** The options a person ticks: everything but the colour groups. */
export const EQUIPMENT = (Object.keys(OPTION_LABELS) as Option[]).filter(
  (option) => !isColour(option),
)

/** Where an option was read, as a tooltip says it. */
export const READ_FROM: Record<OptionRead['read_from'], string> = {
  features: 'From the listing’s features',
  description: 'From the seller’s description',
  colour: 'From the listing’s colour',
}
